import React, { useState, useEffect, useRef, useContext } from "react";
import DynamicIcon from "../../components/dynamicicon";
import { Link, useNavigate, useParams } from "react-router-dom";
import * as Constants from "../../constants";
import { ShareContext } from "../../context/ShareContext";
import BackLoader from "../../components/backloader";
import JisButton from "../../components/controls/jisButton";
import CaseSearch from "../../components/core/case_search";
import JisEmptyList from "../../components/controls/emptylist";
import Pagenated from "../../components/pagenated";
import CaseDetails from "../../components/core/caseDetails";
import JisDialog from "../../components/dialog";
import JisYesNo from "../../components/controls/jisYesNo";
import JisCheckbox from "../../components/controls/jisCheckbox";
import moment from "moment";
import JisDialogForm from "../../components/formdialog";
import JisTabButton from "../../components/controls/jisTabButton";
import PdfViewer from "../../components/controls/pdfviewer";
import JisPrepareTemplate from "../../components/core/preparetemplate";
import DeadlineBadge from "../../components/controls/deadlinebadge";
import CustomSearchSortHeader from "../../components/core/CustomSearchSortHeader";
import wordicon from "../../assets/ms_word.png";
import excelicon from "../../assets/ms_excel.png";
import pdficon from "../../assets/pdf.png";
import useComments from "../../hooks/useComment";

const CommentDropdown = ({
  onChange,
  name,
  placeholder,
  required,
  reasonPlaceHolder,
}) => {
  const { token } = useContext(ShareContext);
  //  Fetch predefined comments
  const { comments: predefinedComments } = useComments(token);

  const [selectedComments, setSelectedComments] = useState([]);
  const [value, setValue] = useState("");

  // Load predefined selections from value
  useEffect(() => {
    if (value && predefinedComments.length > 0) {
      const parts = value
        .split(",")
        .map((v) => v.trim())
        .filter(Boolean);

      const predefinedSelected = parts.filter((p) =>
        predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p,
        ),
      );

      setSelectedComments(predefinedSelected);
    }
  }, [value, predefinedComments]);

  // Update parent component
  const updateParent = (finalValue) => {
    setValue(finalValue);
    if (onChange) {
      onChange({ target: { name, value: finalValue } });
    }
  };

  // Merge and update the parent
  const updateFinal = (updatedSelected, customText) => {
    const cleanedCustom = customText.split(",").map((v) => v.trim());

    const finalValue = [...updatedSelected, ...cleanedCustom]
      .filter(Boolean)
      .join(", ");

    updateParent(finalValue);
  };

  // Handle checkbox change
  const handleCheckboxChange = (e) => {
    const { checked, value: comment } = e.target;

    const updatedSelected = checked
      ? [...selectedComments, comment]
      : selectedComments.filter((c) => c !== comment);

    setSelectedComments(updatedSelected);

    // Get current custom text (non-predefined parts)
    const currentParts = (value || "")
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const customOnly = currentParts.filter(
      (p) =>
        !predefinedComments.some((comment) =>
          typeof comment === "string" ? comment === p : comment.source === p,
        ),
    );

    updateFinal(updatedSelected, customOnly.join(", "));
  };

  // Handle textarea typing
  const handleCustomChange = (e) => {
    const inputText = e.target.value;

    // Update parent immediately for responsive typing
    updateParent(inputText);

    // Update internal selected comments based on what's typed
    const parts = inputText
      .split(",")
      .map((v) => v.trim())
      .filter(Boolean);

    const predefinedInText = parts.filter((p) =>
      predefinedComments.some((comment) =>
        typeof comment === "string" ? comment === p : comment.source === p,
      ),
    );
    setSelectedComments(predefinedInText);
  };

  return (
    <div>
      {reasonPlaceHolder && (
        <p className="reason_placeholder">{reasonPlaceHolder}</p>
      )}
      <div className="predefined_comment_wrapper">
        {predefinedComments.map((comment, index) => {
          const commentText =
            typeof comment === "string" ? comment : comment.source;
          return (
            <label key={index} className="predefined_checkbox_wrapper">
              <input
                type="checkbox"
                value={commentText}
                checked={selectedComments.includes(commentText)}
                onChange={handleCheckboxChange}
              />
              <p>{commentText}</p>
            </label>
          );
        })}
      </div>

      <div>
        <label style={{ marginBottom: "120px" }} htmlFor="comments">
          comment
        </label>
        <textarea
          className="predefinedComments_textarea"
          placeholder={placeholder}
          required={required}
          value={value}
          onChange={(e) => handleCustomChange(e)}
          style={{ width: "100%", minHeight: "120px", padding: "8px" }}
        />
      </div>
    </div>
  );
};

function AdrAdminCases() {
  const navigate = useNavigate();
  const { managertype } = useParams();
  const { activePage, token, profile, frequentData, setIsExpired, setAlert,holidays } =
    useContext(ShareContext);
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(Constants.PAGESIZE);
  const [isSearch, setIsSearch] = useState(false);
  const [search, setSearch] = useState(null);
  const [err, setErr] = useState("");
  const [isPreview, setIsPreview] = useState(false);
  const [count, setCount] = useState(0);
  const [active, setActive] = useState(null);
  const [index, setIndex] = useState(-1);
  const [openCase, setOpenCase] = useState(false);
  const [isCmc, setIsCmc] = useState(null);
  const [openOption, setOpenOption] = useState(false);
  const [comment, setComment] = useState("");
  const [option, setOption] = useState({});

  const [selected, setSelected] = useState(new Set()); //to hold the selected
  const [roles, setRoles] = useState([]);
  const [judges, setJudges] = useState([]);
  const [selectedCases, setSelectedCases] = useState({});
  const [assignTo, setAssignTo] = useState(null);
  const [openClear, setOpenClear] = useState(false);
  const [clearCommnent, setClearComment] = useState("");
  const [caseStatusId, setCaseStatusId] = useState(88); //default move to ADR
  const [caseStatus, setCaseStatus] = useState("pending"); //casesatusid 88
  const [roleCase, setRoleCase] = useState("all");
  const [sFile, setSFile] = useState(null);
  const [previewPath, setPreviewPath] = useState(false);
  const [clearV, setClearV] = useState(null);
  const [predate, setPredate] = useState("");
  const [pretime, setPretime] = useState("");
  const [appearStatus, setAppearStatus] = useState("Physical");
  const [virtualUrl, setVirtualUrl] = useState("");
  const [availableDate, setAvailableDate] = useState({
    date1: "",
    date2: "",
    date3: "",
  });
  const [dialogTitle, setDialogTitle] = useState("Assignment Cases");
  const [summary, setSummary] = useState("");
  const [kindofuser, setKindofuser] = useState("Manager");
  const [preinfo, setPreInfo] = useState(null);

  const [availableDates, setAvailableDates] = useState(null);
  const [seletedDate, setSelectedDate] = useState(null);
  const [isSettled, setIsSettled] = useState(false);

  //*****************************for term settlement
  const [doc, setDoc] = useState(null);
  const [docline, setDocline] = useState(null);
  const [uplinetype, setUplinetype] = useState("template");
  const [autoFill, setAutoFill] = useState([]);
  const [template, setTemplate] = useState(null);
  const [mediation, setMediation] = useState(null);
  const [settlementSaved, setSettlementSave] = useState(false);

  const [open, setOpen] = useState(false);
  const [isselected, setIsSelected] = useState(null);
  const [default_infavour, setDefaultInfavour] = useState(null);

  const handleSelect = (opt) => {
    setIsSelected(opt);
    setAssignTo(opt.id);
    setOpen(false);
  };

  const onUploadSettlementFile = async () => {
    if (sFile == null) return;
    var payload = {
      caseid: active.caseId,
      comment: clearCommnent,
      id: docline.id,
      uplineType: "attest",
      base64: sFile.base64,
      base64Ext: sFile.base64Ext,
      templateId: 0,
      templatetitle: "",
      filename: sFile.filename,
      docuploadid: doc.id,
    };
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-clear-case/${caseStatus}/${active.caseId}`,
        {
          method: "POST",
          body: JSON.stringify(payload),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        onCloseSettlement();
        setAlert({
          open: true,
          title: "Term of Settlement",
          subtitle: "Document uploaded and case cleared successfully",
        });
        setPageIndex(-1);
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
    }
  };

  const onCloseSettlement = () => {
    setIsSettled(false);
    setUplinetype("template");
    setSFile(null);
    setSettlementSave(false);
    setDoc(null);
    setDocline(null);
    setTemplate(null);
    setMediation(null);
    setClearComment("");
  };

  const onPrepareDone = async (e) => {
    //this is coming from from Prepare Document
    //saving and clearing

    if (clearCommnent == "") {
      setAlert({
        icon: "warning",
        open: true,
        title: "Clear Case",
        subtitle: `Please enter comment`,
      });
      setSettlementSave(true);
      return;
    }
    setLoading(true);
    var approve = { caseid: active.caseId, comment: clearCommnent };
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-clear-case/${caseStatus}/${active.caseId}`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        onCloseSettlement();

        setAlert({
          open: true,
          title: "Case Acceptance",
          subtitle: " CASE CLEARED SUCCESSFULLY",
        });
        setPageIndex(-1); // this will auto load again
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onLoadTemplate = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/load-special-template/${
          mediation?.partiesSettled ? "term-of-settlement" : "non-settlement"
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        setTemplate(data.temp);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoadMediation = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-mediation/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        const med = { ...data.med, attendees: data.med_attendee };
        setMediation(med);
        setDoc(data.docup);
        setDocline(data.docline);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (active != null && mediation != null) {
      onLoadTemplate();
    }
  }, [mediation, isSettled]);

  const onSettlement = (item) => {
    //load a dialog with
    setActive(item);
    setIsSettled(true);
    onLoadMediation(item.caseId);
  };

  /* const onSaveSettilement=()=>{
      //provide comment

    } */
  //***********************************end of term

  useEffect(() => {
    let csid = 0;
    setDialogTitle("Clear case");
    if (managertype == null) {
      setCaseStatus("pending");
      setCaseStatusId(88);
      csid = 88;
      setDialogTitle("Clear case");
      onLoadRoles(117);
    } else if (managertype == "manager1") {
      setCaseStatus("pending-man-1");
      setCaseStatusId(109);
      csid = 109;
    } else if (managertype == "manager2") {
      setCaseStatus("pending-man-2");
      setCaseStatusId(112);
      csid = 112;
    } else if (managertype == "mediator") {
      setCaseStatus("mediator");
      setCaseStatusId(113);
    } else if (managertype == "coordinator") {
      setCaseStatus("coordinator");
      setCaseStatusId(157);
      setDialogTitle("Assign Case to Mediator");
      onLoadRoles(157);
    }
    //    onLoad(csid);
    onLoadSync();
  }, [managertype]);

  useEffect(() => {
    if (pageIndex >= 0) {
      if (search != null) {
        onSearch(search);
      }
    } else {
      setPageIndex(0);
    }
  }, [pageIndex, pageSize, search, caseStatus]);

  useEffect(() => {
    console.log("here for clear_default");
    if (
      (caseStatusId == 110 ||
        caseStatusId == 109 ||
        caseStatusId == 120 ||
        caseStatusId == 168) &&
      openClear &&
      active != null
    ) {
      onLoadClear_default_judgement(active.caseId);
      onLoadpreinfo(active.caseId);
      setSelectedDate(null);
    }

    if (caseStatusId == 126 && active != null) {
      onLoad_default_judgement_status(active.caseId);
    }
  }, [caseStatusId, openClear]);

  const onCheck = (value, opt) => {
    let sel = selected;
    let updateSel = { ...selectedCases };
    if (value) {
      sel.add(opt.caseId);
      updateSel[opt.caseId] = opt;
    } else {
      sel.delete(opt.caseId);
      delete updateSel[opt.caseId];
    }
    setSelected(new Set(sel));
    setSelectedCases(updateSel);
    console.log(Object.keys(updateSel));
  };
  const onSearch = async (sear) => {
    setSearch(sear);
    setLoading(true);

    //call url
    var callurl = "";
    if (caseStatusId == 163 && managertype == null) {
      callurl = `${Constants.apiUrl}/filing/adr-admin-cases-special/substituted-admin/${pageIndex}/${pageSize}`;
    } else if (caseStatusId == 177 && managertype == null) {
      callurl = `${Constants.apiUrl}/filing/adr-admin-cases-special/non-service-expired/${pageIndex}/${pageSize}`;
    } else {
      callurl = `${Constants.apiUrl}/filing/adr-admin-cases/${caseStatusId}/${pageIndex}/${pageSize}`;
    }

    try {
      const resp = await fetch(callurl, {
        method: "POST",
        body: JSON.stringify(sear),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setCases(data.items);
        if (pageIndex == 0) {
          setCount(data.totalCount);
        }
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onLoadSync = async () => {
    //for account registration
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/sync-for-expiration`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();

      onSearch(search);
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadRoles = async (csid) => {
    //for account registration
    let roletype = "manager";
    if (csid == "108" || csid == "117") {
      //including Substituted Service Granted.
      //load all Adr Case Manager users
      setKindofuser("Manager");
      roletype = "manager";
    } else if (csid == "155") {
      roletype = "Coordinator";
      setKindofuser("Coordinator");
    } else if (csid == "157") {
      roletype = "mediator";
      setKindofuser("Mediator");
    }

    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getrolesBySearch/${roletype}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setRoles(data.roles);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  const onLoadUserByRoleandDivision = async () => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/profile/getUsersByRole/${option.roleId}/${option.divisionId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setJudges(data.pros);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    if (
      !(option.divisionId == null || option.divisionId == "") &&
      !(option.roleId == null || option.roleId == "")
    ) {
      setAssignTo(null);
      setJudges([]);
      onLoadUserByRoleandDivision();
    }
  }, [option.divisionId, option.roleId]);

  const onPagePick = (pick) => {
    console.log("this is selection value");
    setPageIndex(pick.id - 1);
    console.log(pick);
  };

  const onContinue = (fee, ind) => {
    navigate(`/case-details/${fee.caseId}`);
    // setActive(fee);
    // setIndex(ind);
    // setOpenCase(true);
  };

  const onCloseOpenCase = () => {
    setActive(null);
    setIndex(-1);
    setOpenCase(false);
    setOpenClear(false);
    setClearV(null);
  };

  const onOptionChange = (e) => {
    setOption({ ...option, [e.target.name]: e.target.value });
  };

  const onDirectSearch = (sear) => {
    setSearch(sear);
    setIsSearch(true);
    setPageIndex(0);
  };

  const onClear = (item, index) => {
    //load a dialog with
    setActive(item);
    setOpenClear(true);
  };

  const onSaveClear = async (e) => {
    e.preventDefault();
    var approve = { caseid: active.caseId, comment: clearCommnent };
    if (caseStatusId == 109 || caseStatusId == 133) {
      onSaveFile();
      return;
    }
    if (caseStatusId == 138) {
      onSaveClosureFile();
      return;
    }

    if (caseStatusId == 110) {
      if (clearV?.servicedOn == null) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Proof of Service ",
          subtitle: `You cannot clear when the proof of service not uploaded and commissioned by CFO`,
        });
        return;
      }
      if (clearV?.isdue == false) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Cannot clear",
          subtitle: `You cannot clear the case as the period of  ${Constants.duration(
            clearV?.md,
          )} not due`,
        });
        return;
      }
    }
    if (caseStatusId == 112) {
      if (predate == "") {
        setAlert({
          icon: "warning",
          open: true,
          title: "Pre-Session Meeting Notification",
          subtitle: `Please specify the date for the pre-session meeting`,
        });
        return;
      }
      approve = {
        ...approve,
        predate,
        pretime,
        appearStatus,
        meetingLink: virtualUrl,
      };
    }
    if (caseStatusId == 113) {
      const availabledate = `${moment(availableDate.date1).format(
        "yyyy-MM-DD",
      )},${moment(availableDate.date2).format("yyyy-MM-DD")},${moment(
        availableDate.date3,
      ).format("yyyy-MM-DD")}`;
      approve = {
        ...approve,
        otherDetails: availabledate,
        summary,
        appearStatus,
        meetingLink: virtualUrl,
      };
    }
    if (caseStatusId == 120) {
      if (seletedDate == null) {
        setAlert({
          icon: "warning",
          open: true,
          title: "Select Mediation Date",
          subtitle: `Please select one of the date listed`,
        });
        return;
      }
      approve = { ...approve, predate: seletedDate, pretime };
    }
    setLoading(true);
    try {
      const resp = await fetch(
        `${Constants.apiUrl}/filing/adr-clear-case/${caseStatus}/${active.caseId}`,
        {
          method: "POST",
          body: JSON.stringify(approve),
          headers: {
            "Content-Type": "application/json, text/plain",
            Authorization: `Bearer ${token}`,
          },
        },
      );

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenClear(false);

        setAlert({
          open: true,
          title: "Case Acceptance",
          subtitle: " Case(s) cleared  successfully",
        });
        setPageIndex(-1); // this will auto load again
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };
  const onCaseStatusChange = (v) => {
    setCases([]);
    setPageIndex(-1);
    setCaseStatus(v);
    setDialogTitle("Clear Case");
    setSelected(new Set());
    setSelectedCases({});

    if (v == "pending") {
      setCaseStatusId(88);
    } else if (v == "going-to-man1") {
      setCaseStatusId(108);
      onLoadRoles(108);
    } else if (v == "going-to-man2") {
      //this is going to cordinator
      setCaseStatusId(155);
      onLoadRoles(155);
    } else if (v == "pending-man-1") {
      setCaseStatusId(109);
    } else if (v == "default") {
      setCaseStatusId(111);
    } else if (v == "casemanager1-submit-report") {
      setCaseStatusId(110);
    } else if (v == "pre-session") {
      setCaseStatusId(156);
    } else if (v == "pending-man-2") {
      setCaseStatusId(112);
      onLoadRoles(112);
    } else if (v == "mediator") {
      setCaseStatusId(113);
    } else if (v == "coordinator") {
      setCaseStatusId(157);
      onLoadRoles(157);
    } else if (v == "mediator-unschedule") {
      setCaseStatusId(120);
    } else if (v == "settled") {
      setCaseStatusId(132);
    } else if (v == "unsettled") {
      setCaseStatusId(133);
    } else if (v == "closure") {
      setCaseStatusId(138);
    } else if (v == "struckout") {
      setCaseStatusId(159);
    } else if (v == "mediator-scheduled") {
      setCaseStatusId(162);
    } else if (v == "substituted" || v == "substituted-admin") {
      setCaseStatusId(163);
    } else if (v == "non-service" || v == "non-service-expired") {
      setCaseStatusId(177);
    } else if (v == "substituted-granted" || v == "substituted-granted-admin") {
      setCaseStatusId(117);
    } else if (v == "substituted-served") {
      setCaseStatusId(168);
    } else if (v == "default-judgement-ordered") {
      setCaseStatusId(126);
    }
  };
  const onProcess = () => {
    setOpenOption(true);
    const oneof = Object.values(selectedCases)[0];
    console.log(oneof);
    setOption({ ...option, divisionId: oneof.divisionId });
  };

  const onSave = async (e) => {
    e.preventDefault();

    if (assignTo == null) {
      setErr("Please selecte one of the listed Manager");
      return;
    }

    var caseids = Array.from(selected);
    setErr("");
    var judgeAs = isCmc == true ? "CMC" : "Trial";
    var approve = {
      ...option,
      isCms: isCmc,
      caseids: caseids,
      assignType: "adr-manager",
      judgeAs: judgeAs,
      assignTo: assignTo,
    };

    setLoading(true);
    try {
      const resp = await fetch(`${Constants.apiUrl}/filing/Assign-Cases`, {
        method: "POST",
        body: JSON.stringify(approve),
        headers: {
          "Content-Type": "application/json, text/plain",
          Authorization: `Bearer ${token}`,
        },
      });

      const data = await resp.json();
      setLoading(false);
      console.log(data);
      if (data.code == 0) {
        //update the field
        setOpenOption(false);

        setAlert({
          open: true,
          title: "Case Assignment",
          subtitle: "Cases assigned  successfully",
        });
        setPageIndex(-1); // this will auto load again
        setSelectedCases({}); //reset the value
      } else if (data.code == -10) {
        setIsExpired(true);
      } else {
        //there is an error
        setErr(data.status);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
      setErr(Constants.serverErr);
      // onMove();
    }
  };

  const handleUploadChange = async (e) => {
    const files = e.target.files;
    console.log(files[0]);
    var b64 = await Constants.toBase64(files[0]);
    var path = URL.createObjectURL(files[0]);
    var fname = Constants.ReduceFilename(files[0]?.name);

    var a = {
      path,
      base64: b64.split(",")[1],
      filename: fname,
      base64Ext: b64.split(",")[0],
      comment: clearCommnent,
    };

    setSFile(a);

    console.log(a);
  };
  const onPreview = (obj) => {
    setIsPreview(true);
    setPreviewPath(obj.path);
  };
  const onSaveFile = () => {
    if (sFile == null) {
      return;
    }
    onUploadFiles2(active.caseId);
  };

  const onSaveClosureFile = () => {
    if (sFile == null) {
      return;
    }
    onUploadFiles2(active.caseId);
  };

  const onUploadFiles2 = async (caseid) => {
    const uploadurl = `${Constants.apiUrl}/filing/upload-adr-manager-document/${caseid}`;
    var upline = {
      id: 0,
      uplineType: "attest",
      base64: sFile.base64,
      base64Ext: sFile.base64Ext,
      templateId: 0,
      templatetitle: "",
      filename: sFile.filename,
      docuploadid: 0,
      comment: clearCommnent,
    };

    //  setFlowError('');

    // Sending the FormData using fetch
    setLoading(true);
    fetch(uploadurl, {
      method: "POST",
      body: JSON.stringify(upline),
      headers: {
        "Content-Type": "application/json, text/plain",
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        setLoading(false);
        if (data.code == 0) {
          //saved already
          setOpenClear(false);

          setAlert({
            open: true,
            title: "Case Summary",
            subtitle: "Case Summary Submitted Successfully",
          });
          setPageIndex(-1); // this will auto load again
        } else if (data.code == -10) {
          setIsExpired(true);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setLoading(false);
      });
  };

  const onLoadClear_default_judgement = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-clear-judgement/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setClearV(data);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const onLoad_default_judgement_status = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-default-judgement-status/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setDefaultInfavour(data.infavour);
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };

  useEffect(() => {
    console.log(caseStatus, caseStatusId);
  }, [caseStatus, caseStatusId]);
  const onLoadpreinfo = async (caseid) => {
    //for account registration
    try {
      setLoading(true);
      const resp = await fetch(
        `${Constants.apiUrl}/filing/get-pre-session/${caseid}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        },
      );
      const data = await resp.json();
      setLoading(false);
      if (data.code == 0) {
        //ready
        // fee, feelines, cinfo , parties
        setPreInfo(data.pre);
        setAvailableDates(data.pre.availableDates.split(","));
      } else if (data.code == -10) {
        setIsExpired(true);
      }
    } catch (error) {
      setLoading(false);
      console.error(error);
    }
  };
  const StartMeeting = (v) => {
    navigate(`/adr-mediation/${v.caseId}`);
  };

  const handleDateChange = (key, value) => {
    const newDates = { ...availableDate, [key]: value };
    const dates = [newDates.date1, newDates.date2, newDates.date3].filter(
      Boolean,
    );

    const hasDuplicates = new Set(dates).size !== dates.length;
    setErr(hasDuplicates ? "Dates must not be the same." : "");
    if (hasDuplicates) return;

    setAvailableDate(newDates);
  };

  const handleCancelSelection = () => {
    setSelectedCases({});
    setSelected(new Set());
  };

  return (
    <div>
      {/* <CaseSearch
        onSearch={onDirectSearch}
        frequentData={frequentData}
        filingtype="adr"
      /> */}
      <CustomSearchSortHeader
        onSearch={onDirectSearch}
        frequentData={frequentData}
      />

      <div className="tab_body">
        <div className="exportdiv">
          <img
            src={wordicon}
            // onClick={() => onExport("word")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={excelicon}
            // onClick={() => onExport("excel")}
            style={{ cursor: "pointer" }}
          />
          <img
            src={pdficon}
            // onClick={() => onExport("pdf")}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div className="case-assignment-tab-container">
          <div className="tab_section">
            {managertype == null && (
              <>
                <JisTabButton
                  code="pending"
                  isActive={caseStatus == "pending"}
                  title="Pending Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("pending")}
                />

                <JisTabButton
                  code="From ADR Judge"
                  isActive={caseStatus == "going-to-man1"}
                  title="From ADR Judge"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("going-to-man1")}
                />

                <JisTabButton
                  code="Ready for Mediation Flow"
                  isActive={caseStatus == "going-to-man2"}
                  title="Ready for Mediation Flow"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("going-to-man2")}
                />

                <JisTabButton
                  code="substituted-admin"
                  isActive={caseStatus == "substituted-admin"}
                  title="Substituted Service Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("substituted-admin")}
                />
                <JisTabButton
                  code="non-service-expired"
                  isActive={caseStatus == "non-service-expired"}
                  title="Non Service Expired Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("non-service-expired")}
                />

                <JisTabButton
                  code="default-judgement-ordered"
                  isActive={caseStatus == "default-judgement-ordered"}
                  title="Default Judgement Ordered"
                  isRoleBased={false}
                  onClick={() =>
                    onCaseStatusChange("default-judgement-ordered")
                  }
                />
              </>
            )}
            {managertype == "manager1" && (
              <>
                <JisTabButton
                  code="pending-man-1"
                  isActive={caseStatus == "pending-man-1"}
                  title="Pending"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("pending-man-1")}
                />

                <JisTabButton
                  code=""
                  isActive={caseStatus == "casemanager1-submit-report"}
                  title="Report Submited"
                  isRoleBased={false}
                  onClick={() =>
                    onCaseStatusChange("casemanager1-submit-report")
                  }
                />

                <JisTabButton
                  code="default"
                  isActive={caseStatus == "default"}
                  title="Default Judgement Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("default")}
                />

                <JisTabButton
                  code="substituted"
                  isActive={caseStatus == "substituted"}
                  title="Substituted Service Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("substituted")}
                />

                <JisTabButton
                  code="non-service"
                  isActive={caseStatus == "non-service"}
                  title="Non Service Expired Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("non-service")}
                />

                <JisTabButton
                  code="struckout"
                  isActive={caseStatus == "struckout"}
                  title="Struck-Out Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("struckout")}
                />

                <JisTabButton
                  code="pending-man-2"
                  isActive={caseStatus == "pending-man-2"}
                  title="Mediation Path"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("pending-man-2")}
                />

                <JisTabButton
                  code="mediator-unschedule"
                  isActive={caseStatus == "mediator-unschedule"}
                  title="Unscheduled Mediation"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("mediator-unschedule")}
                />

                <JisTabButton
                  code="settled"
                  isActive={caseStatus == "settled"}
                  title="Settled Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("settled")}
                />
                <JisTabButton
                  code="unsettled"
                  isActive={caseStatus == "unsettled"}
                  title="Unsettled Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("unsettled")}
                />
                <JisTabButton
                  code="closure"
                  isActive={caseStatus == "closure"}
                  title="Closure Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("closure")}
                />
                <JisTabButton
                  code="substituted-granted"
                  isActive={caseStatus == "substituted-granted"}
                  title="Substituted Granted"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("substituted-granted")}
                />
                <JisTabButton
                  code="substituted-served"
                  isActive={caseStatus == "substituted-served"}
                  title="Substituted Served"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("substituted-served")}
                />
              </>
            )}
            {managertype == "mediator" && (
              <>
                <JisTabButton
                  code="mediator"
                  isActive={caseStatus == "mediator"}
                  title="Pending"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("mediator")}
                />
                <JisTabButton
                  code="mediator-scheduled"
                  isActive={caseStatus == "mediator-scheduled"}
                  title="Scheduled Mediation Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("mediator-scheduled")}
                />
                <JisTabButton
                  code="unsettled"
                  isActive={caseStatus == "unsettled"}
                  title="Unsettled Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("unsettled")}
                />
              </>
            )}
            {managertype == "coordinator" && (
              <>
                <JisTabButton
                  code="corrdinator"
                  isActive={caseStatus == "coordinator"}
                  title="Pending"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("coordinator")}
                />
              </>
            )}
            {managertype == "manager2" && (
              <>
                <JisTabButton
                  code="pending-man-2"
                  isActive={caseStatus == "pending-man-2"}
                  title="Pending"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("pending-man-2")}
                />
                <JisTabButton
                  code="pre-session"
                  isActive={caseStatus == "pre-session"}
                  title="Pre-Session"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("pre-session")}
                />
                <JisTabButton
                  code="settled"
                  isActive={caseStatus == "settled"}
                  title="Settled Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("settled")}
                />
                <JisTabButton
                  code="unsettled"
                  isActive={caseStatus == "unsettled"}
                  title="Unsettled Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("unsettled")}
                />
                <JisTabButton
                  code="closure"
                  isActive={caseStatus == "closure"}
                  title="Closure Cases"
                  isRoleBased={false}
                  onClick={() => onCaseStatusChange("closure")}
                />
              </>
            )}
          </div>

          {Object.keys(selectedCases).length > 0 && (
            // <JisButton onClick={onProcess}>
            //   {" "}
            //   Bulk Asign ({Object.keys(selectedCases).length})
            // </JisButton>
            <div className="case-assignment-btn-container">
              <button className="case-assignment-btn-solid" onClick={onProcess}>
                {Object.keys(selectedCases).length === 1
                  ? "Assign (1)"
                  : `Bulk Assign (${Object.keys(selectedCases).length})`}
              </button>
              <button
                onClick={handleCancelSelection}
                className="case-assignment-btn-outline"
              >
                Cancel selection
              </button>
            </div>
          )}
        </div>

        <div className="tab_view">
          {cases?.length == 0 && <JisEmptyList />}
          {cases?.length > 0 && (
            <div className="table">
              <div class="section-cases">
                <span>
                  {managertype == null
                    ? "ADR ADMINISTRATOR CASES"
                    : managertype == "coordinator"
                      ? "ADR COORDINATOR CASES"
                      : managertype == "mediator"
                        ? "ADR MEDIATOR CASES"
                        : "Cases"}
                </span>
              </div>
              <div className="table-wrapper">
                <table className="case-table">
                  <thead>
                    <tr>
                      <th className="col-title">Suit Number</th>
                      <th className="col-title">Case Title</th>
                      <th className="col-medium">Date Initiated</th>
                      {/* {managertype !== undefined && (
                        <>
                          <th className="col-medium">Filing Type</th>
                          <th className="col-medium">Classification</th>
                        </>
                      )} */}
                      <th className="col-medium">Case Age</th>
                      {/* {managertype !== undefined && <th className="col-medium">Status Level</th>} */}
                      <th>SLA</th>
                      <th className="col-title">Details</th>
                      <th className="col-action">
                        {" "}
                        {caseStatus.toLowerCase() === "substituted-admin"
                          ? "Assign"
                          : "Acion"}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map((opt, index) => {
                      const cc = Constants.getSlaTimeLeft(opt.slaExpire,holidays);
                      return (
                        <tr key={index}>
                          <td
                            style={{
                              backgroundColor: `${
                                Constants.getItemById(
                                  frequentData?.casecategories,
                                  opt.caseCategoryId,
                                )?.colour
                              }`,
                            }}
                          >
                            {opt.caseNumber}
                          </td>
                          <td>{opt.caseTitle}</td>
                          <td>
                            {" "}
                            {Constants.momentDate(opt.createdOn).format(
                              "DD MMM, YYYY",
                            )}
                          </td>
                          {/* {managertype !== undefined && (
                            <>
                              <td>
                                {
                                  Constants.getItemById(
                                    frequentData?.casetype,
                                    opt.caseTypeId
                                  )?.caseType1
                                }
                              </td>
                              <td>
                                {" "}
                                {
                                  Constants.getItemById(
                                    frequentData?.casecategories,
                                    opt.caseCategoryId
                                  )?.categoryTitle
                                }
                              </td>
                            </>
                          )} */}
                          <td>{moment().diff(opt.createdOn, "days")}</td>

                          {/* {managertype !== undefined && (
                            <td>
                              {
                                Constants.getItemById(
                                  frequentData?.casestatuses,
                                  opt.caseStatusId
                                )?.description
                              }
                            </td>
                          )} */}
                          <td>
                            {" "}
                            <DeadlineBadge dateString={opt.slaExpire} />{" "}
                          </td>

                          <td>
                            <JisButton
                              variant="plain"
                              onClick={() => onContinue(opt, index)}
                            >
                              View
                            </JisButton>
                          </td>

                          {(caseStatusId == 88 ||
                            caseStatusId == 112 ||
                            caseStatusId == 156 ||
                            caseStatusId == 113 ||
                            caseStatusId == 111 ||
                            caseStatusId == 120 ||
                            caseStatusId == 159 ||
                            caseStatus == "substituted-granted" ||
                            caseStatusId == 168 ||
                            caseStatusId == 126) && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onClear(opt, index)}
                              >
                                Clear
                              </JisButton>
                            </td>
                          )}
                          {(caseStatusId == 108 ||
                            caseStatusId == 155 ||
                            caseStatus == "substituted-admin" ||
                            caseStatus == "non-service-expired" ||
                            caseStatusId == 157) && (
                            <td>
                              <JisCheckbox
                                onChange={(e) => onCheck(e, opt)}
                                value={selected.has(opt.caseId)}
                              />
                            </td>
                          )}
                          {(caseStatusId == 109 || caseStatusId == 110) && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onClear(opt, index)}
                              >
                                Clear
                              </JisButton>
                            </td>
                          )}
                          {caseStatusId == 162 && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => StartMeeting(opt)}
                              >
                                Start Meeting
                              </JisButton>
                            </td>
                          )}
                          {caseStatusId == 132 && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onSettlement(opt)}
                              >
                                Term of Settlement
                              </JisButton>
                            </td>
                          )}
                          {(caseStatusId == 138 || (caseStatusId == 177 && caseStatus != "non-service-expired")) && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onClear(opt, index)}
                              >
                                Clear
                              </JisButton>
                            </td>
                          )}
                          {caseStatusId == 133 && (
                            <td>
                              <JisButton
                                variant="plain"
                                onClick={() => onClear(opt, index)}
                              >
                                Inability To Settle Report
                              </JisButton>
                            </td>
                          )}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
              {cases?.length > 0 && (
                <Pagenated
                  size={pageSize}
                  total={count}
                  maxPage={20}
                  onPick={onPagePick}
                />
              )}
            </div>
          )}
        </div>
      </div>

      <BackLoader open={loading} />

      {openCase && active != null && (
        <JisDialogForm title="Case Details" onClose={onCloseOpenCase}>
          <div>
            <CaseDetails
              caseId={active.caseId}
              data={null}
              token={token}
              initialtab="casedocuments"
            />
          </div>
        </JisDialogForm>
      )}

      {openClear &&
        active != null &&
        (caseStatusId == 88 ||
          caseStatusId == 109 ||
          caseStatusId == 110 ||
          caseStatusId == 112 ||
          caseStatusId == 120 ||
          caseStatusId == 156 ||
          caseStatusId == 113 ||
          caseStatusId == 138 ||
          caseStatusId == 177 ||
          caseStatusId == 133 ||
          caseStatusId == 111 ||
          caseStatusId == 159 ||
          caseStatusId == 163 ||
          // caseStatusId == 117 ||
          caseStatus == "substituted-granted" ||
          caseStatusId == 168 ||
          caseStatusId == 126) && (
          <JisDialogForm title={dialogTitle} onClose={onCloseOpenCase}>
            <form onSubmit={onSaveClear}>
              {/* <h4>
                {active?.caseNumber}: {active?.caseTitle}
              </h4> */}
              <h4 className="suit-number-header">
                Suit number:{" "}
                <span style={{ fontWeight: 400 }}>{active?.caseNumber}</span>
              </h4>

              {/* {caseStatusId == 88 && (
                <div className="clear-case-checkbox">
                  <JisCheckbox
                    label="Default Flow (Case Assignment Judge and Deputy Sheriff) "
                    value={true}
                    onChange={(e) => console.log(`check option ${e}`)}
                  />
                </div>
              )} */}

              {(caseStatusId == 110 || caseStatusId == 168) && (
                <>
                  <p>
                    Case will be available for Default Judgement. (Condition
                    applied){" "}
                  </p>
                  {/*  <div className='note'>{`Serviced on ${clearV?.servicedOn && Constants.momentDate(clearV?.servicedOn).format('DD MMM, YYYY')}  setperiod ${ Constants.duration(clearV?.md) } timediff ${Constants.duration(clearV?.timediff) }.  ${clearV?.isdue?'Case Due for Default Judgement':'Case Not Due for Judgement'}`}</div> */}
                  {clearV != null && clearV.servicedOn != null && (
                    <div
                      className={`${clearV?.isdue ? "success-box" : "error"}`}
                    >{` ${
                      clearV?.isdue
                        ? "Case Due for Default Judgement"
                        : "Case Not Due for Default Judgement"
                    }`}</div>
                  )}
                  {clearV != null && clearV.servicedOn == null && (
                    <div className="error">
                      This case Affidavit of service is not uploaded yet
                    </div>
                  )}
                </>
              )}
              {caseStatusId == 111 && (
                <>
                  <div>Case is going back ADR Judge for Scheduling</div>
                </>
              )}
              {caseStatusId == 159 && (
                <>
                  <div>
                    Sends case to ADR Judge to who lists the matter and strikes
                    it out for want of diligent prosecution
                  </div>
                </>
              )}
              {(caseStatusId == 138 || caseStatusId == 177) && (
                <>
                  <div>Case Summary</div>
                </>
              )}
              {caseStatusId == 133 && (
                <>
                  <div>Inability to Settle report</div>
                </>
              )}
              {caseStatusId == 163 && (
                <>
                  <div>Case is going back ADR Judge for Scheduling</div>
                </>
              )}
              {caseStatusId == 117 && (
                <>
                  <div>
                    Case Manager send case to service sheriff to serve
                    Substituted Order
                  </div>
                </>
              )}
              {caseStatusId == 126 && (
                <>
                  <div>
                    {default_infavour == true
                      ? "Order Favour Claimant. The Judgement will be considered as final"
                      : "The Order did not favour Claimant. Case is going to Mediation"}
                  </div>
                </>
              )}

              {(caseStatusId == 109 ||
                caseStatusId == 138 ||
                caseStatusId == 177 ||
                caseStatusId == 133) && (
                <div style={{ display: "flex" }}>
                  <div className="btn-upload">
                    <input
                      type="file"
                      accept="application/pdf"
                      id={`file-upload-${0}`}
                      onChange={(e) => handleUploadChange(e)}
                    />
                    <label htmlFor={`file-upload-${0}`} title={sFile?.filename}>
                      {sFile?.path == null
                        ? "Choose File"
                        : Constants.ReduceString(sFile?.filename, 30)}
                    </label>
                    {sFile?.path != null && (
                      <JisButton onClick={() => onPreview(sFile)}>
                        Preview
                      </JisButton>
                    )}
                  </div>
                </div>
              )}
              {caseStatusId == 112 && (
                <>
                  <p>
                    System will send emails to the parties with the date for
                    Pre-session meeting
                  </p>
                  <div style={{ display: "flex" }}>
                    <div className="input-group">
                      <label> Pre-session meeting Date</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="date" />
                        <input
                          placeholder="Pre Session Date"
                          value={predate}
                          onChange={(e) => setPredate(e.target.value)}
                          required={true}
                          type="date"
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label> Pre-session meeting Time</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="time" />
                        <input
                          placeholder="Pre Session Time"
                          value={pretime}
                          onChange={(e) => setPretime(e.target.value)}
                          required={true}
                          type="time"
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className={`selected ${
                        appearStatus == "Physical" ? "active" : ""
                      } `}
                      onClick={() => setAppearStatus("Physical")}
                    >
                      Physical Only
                    </div>
                    <div
                      className={`selected ${
                        appearStatus == "Virtual" ? "active" : ""
                      } `}
                      onClick={() => setAppearStatus("Virtual")}
                    >
                      Virtual Only
                    </div>
                    <div
                      className={`selected ${
                        appearStatus == "Hybrid" ? "active" : ""
                      } `}
                      onClick={() => setAppearStatus("Hybrid")}
                    >
                      Hybrid
                    </div>
                  </div>
                  {(appearStatus == "Virtual" || appearStatus == "Hybrid") && (
                    <div className="input-group">
                      <label> Virtual Meeting Link</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="video" />
                        <input
                          placeholder="Virtual Meeting Link"
                          value={virtualUrl}
                          onChange={(e) => setVirtualUrl(e.target.value)}
                          required={true}
                        />
                      </div>
                    </div>
                  )}
                </>
              )}

              {caseStatusId == 113 && (
                <>
                  <p>Select 3 Tentative date meeting</p>
                  <div style={{ display: "flex" }}>
                    <div className="input-group">
                      <label> Tentative Date 1</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="date" />
                        <input
                          placeholder="Tentative Date "
                          value={availableDate.date1}
                          onChange={(e) =>
                            handleDateChange("date1", e.target.value)
                          }
                          required={true}
                          type="date"
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label> Tentative Date 2</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="date" />
                        <input
                          placeholder="Tentative Date 2 "
                          value={availableDate.date2}
                          onChange={(e) =>
                            handleDateChange("date2", e.target.value)
                          }
                          required={true}
                          type="date"
                          min={availableDate.date1}
                        />
                      </div>
                    </div>
                    <div className="input-group">
                      <label> Tentative Date 3 </label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="date" />
                        <input
                          placeholder="Tentative Date 3 "
                          value={availableDate.date3}
                          onChange={(e) =>
                            handleDateChange("date3", e.target.value)
                          }
                          required={true}
                          type="date"
                          min={availableDate.date2}
                        />
                      </div>
                    </div>
                  </div>
                  <div style={{ display: "flex" }}>
                    <div
                      className={`selected ${
                        appearStatus == "Physical" ? "active" : ""
                      } `}
                      onClick={() => setAppearStatus("Physical")}
                    >
                      Physical Only
                    </div>
                    <div
                      className={`selected ${
                        appearStatus == "Virtual" ? "active" : ""
                      } `}
                      onClick={() => setAppearStatus("Virtual")}
                    >
                      Virtual Only
                    </div>
                    <div
                      className={`selected ${
                        appearStatus == "Hybrid" ? "active" : ""
                      } `}
                      onClick={() => setAppearStatus("Hybrid")}
                    >
                      Hybrid
                    </div>
                  </div>
                  {(appearStatus == "Virtual" || appearStatus == "Hybrid") && (
                    <div className="input-group">
                      <label> Virtual Meeting Link</label>
                      <div className="input-wrapper">
                        <DynamicIcon iname="video" />
                        <input
                          placeholder="Virtual Meeting Link"
                          value={virtualUrl}
                          onChange={(e) => setVirtualUrl(e.target.value)}
                          required={true}
                        />
                      </div>
                    </div>
                  )}
                  <div className="input-group">
                    <label>
                      Summary <span className="required">*</span>{" "}
                    </label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="group" />
                      <textarea
                        placeholder=" Summary"
                        name="summary"
                        required={true}
                        value={summary}
                        onChange={(e) => setSummary(e.target.value)}
                      />
                    </div>
                  </div>
                </>
              )}
              {caseStatusId == 120 && (
                <>
                  <p>Please select one of the listed date</p>
                  {availableDates != null && (
                    <div>
                      {availableDates.map((opt, index) => (
                        <div
                          className={`selected ${
                            opt == seletedDate ? "active" : ""
                          } `}
                          onClick={() => setSelectedDate(opt)}
                        >
                          {moment(opt).format("DD ddd, MMM yyyy")}
                        </div>
                      ))}
                    </div>
                  )}
                  <p>
                    Meeting will be <strong>{preinfo?.appearStatus}</strong>{" "}
                    {!(
                      preinfo?.virtualUrl == null || preinfo?.virtualUrl == ""
                    ) && (
                      <span>
                        with{" "}
                        <a
                          href={preinfo?.virtualUrl}
                          target="_blank"
                          rel="noreferrer"
                        >
                          virtual link
                        </a>{" "}
                      </span>
                    )}
                  </p>
                  <div className="input-group" style={{ marginTop: 24 }}>
                    <label> Mediation meeting Time</label>
                    <div className="input-wrapper">
                      <DynamicIcon iname="time" />
                      <input
                        placeholder="Mediation meeting Time"
                        value={pretime}
                        onChange={(e) => setPretime(e.target.value)}
                        required={true}
                        type="time"
                      />
                    </div>
                  </div>
                </>
              )}

              <div className="input-group">
                <CommentDropdown
                  placeholder="comment"
                  required={true}
                  reasonPlaceHolder={"Reason (select all that apply)"}
                  onChange={(e) => setClearComment(e.target.value)}
                  name="clearComment"
                />
              </div>
              {err != "" && <div className="error">{err}</div>}
              <div className="clear-case-button-group">
                <JisButton
                  variant="plain"
                  type="button"
                  onClick={onCloseOpenCase}
                >
                  Cancel{" "}
                </JisButton>
                <JisButton type="submit">Save </JisButton>
              </div>
            </form>
          </JisDialogForm>
        )}

      {openOption &&
        (caseStatusId == 108 ||
          caseStatusId == 112 ||
          caseStatusId == 155 ||
          caseStatus == "substituted-admin" ||
          caseStatus == "non-service-expired" ||
          caseStatusId == 157) && (
          <div className="litigation_dialog_wrapper">
            <div className="litigation_dialog_container">
              <div className="dialog_header">
                <p>Assign Case</p>
                <button className="" onClick={() => setOpenOption(false)}>
                  <DynamicIcon size={24} color="white" iname="circle-x" />
                </button>
              </div>
              <form style={{ marginTop: "32px" }} onSubmit={onSave}>
                <div style={{ display: "flex", gap: "32px" }}>
                  <div style={{ flex: 3 }}>
                    {caseStatusId == 155 &&
                      Object.values(selectedCases).length > 1 && (
                        <p style={{ fontWeight: 600, fontSize: "20px" }}>
                          List of ADR Cordinator
                        </p>
                      )}
                    {(caseStatusId == 108 ||
                      caseStatusId == 117 ||
                      caseStatusId == 177) &&
                      Object.values(selectedCases).length > 1 && (
                        <p style={{ fontWeight: 600, fontSize: "20px" }}>
                          List of Case Manager
                        </p>
                      )}
                    {caseStatusId == 157 &&
                      Object.values(selectedCases).length > 1 && (
                        <p style={{ fontWeight: 600, fontSize: "20px" }}>
                          List of Case Mediator
                        </p>
                      )}
                    {Object.values(selectedCases).length === 1 && (
                      <div
                        style={{
                          display: "flex",
                          gap: "12px",
                          alignItems: "center",
                        }}
                      >
                        <p
                          style={{
                            fontWeight: 600,
                            fontSize: "18px",
                          }}
                        >
                          Details:
                        </p>
                        {Object.values(selectedCases).map((obj) => (
                          <div
                            style={{
                              maxWidth: "450px",
                              textWrap: "nowrap",
                              textOverflow: "ellipsis",
                            }}
                          >
                            <p>{obj.caseNumber}</p>
                            <p>{obj.caseTitle}</p>
                          </div>
                        ))}
                      </div>
                    )}
                    <div>
                      <div className="select-group">
                        <label> Division </label>
                        <select
                          name="divisionId"
                          value={option.divisionId}
                          onChange={onOptionChange}
                          required
                        >
                          <option value="">Select </option>
                          {frequentData.divisions?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.title}
                            </option>
                          ))}
                        </select>
                      </div>
                      <div className="select-group">
                        <label>Role:</label>
                        <select
                          name="roleId"
                          value={option.roleId}
                          onChange={onOptionChange}
                          required
                        >
                          <option value="">Select Role </option>
                          {roles?.map((opt) => (
                            <option key={opt.id} value={opt.id}>
                              {opt.name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    <div className="select-group">
                      <label>{kindofuser}</label>

                      <select
                        name="caseManager"
                        value={assignTo}
                        onChange={(e) => {
                          const selected = judges.find(
                            (j) => j.id == e.target.value,
                          );
                          setAssignTo(e.target.value);
                          setIsSelected(selected);
                        }}
                        required
                        className="default-select"
                      >
                        <option value="">Select</option>

                        {judges.map((opt) => (
                          <option key={opt.id} value={opt.id}>
                            {Constants.judgeName(opt)}
                          </option>
                        ))}
                      </select>
                    </div>

                    {/* { caseStatusId==157 && <div  className="input-group">
                                <label>Summary <span className="required">*</span> </label>
                                <div className='input-wrapper'>
                                    <DynamicIcon iname="group" />
                                    <textarea placeholder=' Summary' name='summary' required={true}  value={option.summary}
                            onChange={onOptionChange }  />
                                </div>
                            </div>} */}
                    <div className="input-group">
                      <CommentDropdown
                        placeholder=" Comment"
                        required={true}
                        reasonPlaceHolder={"Reason (select all that apply)"}
                        onChange={(e) =>
                          onOptionChange({
                            target: { name: "comment", value: e.target.value },
                          })
                        }
                        name="comment"
                      />
                    </div>
                    {err != "" && <div className="error">{err}</div>}
                    <div className="assign-case-button-group">
                      <button
                        type="button"
                        onClick={() => setOpenOption(false)}
                        style={{
                          height: "100%",
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        style={{
                          height: "55px",
                        }}
                        className="btn-solid"
                        type="submit"
                      >
                        Save
                      </button>
                    </div>
                  </div>
                  {Object.values(selectedCases).length > 1 && (
                    <div
                      style={{
                        flex: 1,
                        minWidth: "225px",
                        gap: "16px",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      {/* <div>
                    Selected Cases to Assign (
                    {Object.values(selectedCases).length})
                  </div> */}
                      {Object.values(selectedCases)
                        .slice(0, 3)
                        ?.map((opt, index) => (
                          <div className="selected_case" key={index}>
                            <div>{opt.caseNumber}</div>
                            <p style={{ fontSize: 12 }}>{opt.caseTitle}</p>
                          </div>
                        ))}

                      {Object.values(selectedCases).length > 3 && (
                        <p
                          style={{
                            fontSize: 16,
                            fontWeight: 500,
                            lineHeight: "20px",
                          }}
                        >
                          +{Object.values(selectedCases).length - 3} more case
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </form>
            </div>
          </div>
        )}

      {isPreview && (
        <JisDialogForm
          title="Preview"
          onClose={() => setIsPreview(false)}
          minWidth="70%"
        >
          <div style={{ height: 500 }}>
            <PdfViewer pdfUrl={previewPath} />
          </div>
        </JisDialogForm>
      )}

      {isSettled && (
        <JisDialogForm title="Term of Settlement" onClose={onCloseSettlement}>
          <div>
            {/* <div>Term of Settlement.</div> */}

            <div style={{ marginLeft: "auto" }}>
              <p style={{ padding: 8 }}>Type Of Document </p>
              <div style={{ display: "flex", maxWidth: 450 }}>
                <div
                  className={`selected ${
                    uplinetype == "template" ? "active" : ""
                  }`}
                  onClick={() => setUplinetype("template")}
                >
                  Template
                </div>
                <div
                  className={`selected ${
                    uplinetype == "attest" ? "active" : ""
                  }`}
                  onClick={() => setUplinetype("attest")}
                >
                  Upload Document
                </div>
              </div>

              {uplinetype == "attest" && (
                <div style={{ display: "flex", marginTop: 8 }}>
                  <div className="btn-upload">
                    <input
                      type="file"
                      accept="application/pdf"
                      id="settlement-file-upload"
                      onChange={(e) => handleUploadChange(e)}
                    />
                    <label
                      htmlFor="settlement-file-upload"
                      title={sFile?.filename}
                    >
                      {sFile?.path == null
                        ? "Choose File"
                        : Constants.ReduceString(sFile?.filename, 30)}
                    </label>
                    {sFile?.path != null && (
                      <JisButton onClick={() => onPreview(sFile)}>
                        Preview
                      </JisButton>
                    )}
                  </div>
                  {sFile?.path != null && (
                    <JisButton type="button" onClick={onUploadSettlementFile}>
                      Save File
                    </JisButton>
                  )}
                </div>
              )}

              {uplinetype == "template" && (
                <>
                  {!settlementSaved && (
                    <div className="view-doc">
                      {doc != null && docline != null && template != null && (
                        <JisPrepareTemplate
                          templatedoc={{
                            ...doc,
                            upline: docline,
                            template: template,
                          }}
                          docInfo={active}
                          isLegal={true}
                          onDone={onPrepareDone}
                          doctype="settlement"
                          autoFill={autoFill}
                        />
                      )}
                    </div>
                  )}
                  {settlementSaved && (
                    <div className="success-box">Term of Settlement saved.</div>
                  )}
                  {settlementSaved && (
                    <JisButton
                      type="button"
                      onClick={() => onPrepareDone("from button")}
                    >
                      Save
                    </JisButton>
                  )}
                </>
              )}

              {uplinetype == "template" && (
                <div className="input-group">
                  <CommentDropdown
                    placeholder="comment"
                    required={false}
                    reasonPlaceHolder={"Reason (select all that apply)"}
                    onChange={(e) => setClearComment(e.target.value)}
                    name="clearComment"
                  />
                </div>
              )}
            </div>
          </div>
        </JisDialogForm>
      )}
    </div>
  );
}

export default AdrAdminCases;
